import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {
    currentYear: () => {
      return new Date().getFullYear();
    },
  },
  mutations: {},
  actions: {},
  modules: {},
});
